// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3ipQS","messages":"Chat_messages__34I6J","dateDivider":"Chat_dateDivider__o8zE7"};